import { render, staticRenderFns } from "./ContactTypeList.vue?vue&type=template&id=5f29a32e&"
import script from "./ContactTypeList.vue?vue&type=script&lang=js&"
export * from "./ContactTypeList.vue?vue&type=script&lang=js&"
import style0 from "./ContactTypeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports